const ACCESS_TOKEN_REFRESH_SKEW_MS = 60_000
const FALLBACK_REFRESH_DELAY_MS = 15 * 60_000

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/')
  const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4))
  return globalThis.atob(normalized + padding)
}

export const resolveAccessTokenExpirationMs = (token: string): number | null => {
  try {
    const [, payload = ''] = token.split('.')
    if (!payload) return null
    const decoded = JSON.parse(decodeBase64Url(payload)) as { exp?: unknown }
    return typeof decoded.exp === 'number' && Number.isFinite(decoded.exp)
      ? decoded.exp * 1_000
      : null
  } catch {
    return null
  }
}

export const resolveAccessTokenRefreshDelayMs = (
  token: string,
  nowMs = Date.now(),
): number => {
  const expiresAt = resolveAccessTokenExpirationMs(token)
  if (expiresAt === null) return FALLBACK_REFRESH_DELAY_MS
  return Math.max(0, expiresAt - nowMs - ACCESS_TOKEN_REFRESH_SKEW_MS)
}
